import { render } from "./ListadoSolicitudesArticulos.vue?vue&type=template&id=8733bea6&scoped=true"
import script from "./ListadoSolicitudesArticulos.vue?vue&type=script&lang=js"
export * from "./ListadoSolicitudesArticulos.vue?vue&type=script&lang=js"

import "./ListadoSolicitudesArticulos.vue?vue&type=style&index=0&id=8733bea6&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8733bea6"]])

export default __exports__